import { Guard, GuardService } from 'commons/components/guard/guard.component';
import { routeIsAllowed } from 'core/utils/auth-provider-config';
import { useLocation } from 'react-router-dom';
import ErrorScene from 'scenes/error/error.scene';
import { useAuthContext } from './hooks/use-auth-context.hook';

const ProtectedRoute = ({ children }: React.PropsWithChildren) => {
    const { isAuthenticated, userRole } = useAuthContext();
    const { pathname } = useLocation();

    const guardService: GuardService<unknown> = {
        checkPermissions: () => isAuthenticated && !!routeIsAllowed(userRole, pathname),
    };

    return (
        <Guard guardService={guardService} requiredPermissions={false} forbidden={<ErrorScene />}>
            {children}
        </Guard>
    );
};

export default ProtectedRoute;
